import React, { Component } from "react";

export class Tech extends Component {
  render() {
    return (
      <div className="Tech" data-aos="fade-right">
        <p>
          <mark>React.js</mark> javascript <mark>UI </mark>
          <mark>Nuxt.js</mark>
        </p>
        <p>
          Express <mark>Node.Js</mark> Sequelize
        </p>
        <p>
          <mark>Framer-motion</mark> Firebase <mark>Next.Js</mark>
        </p>
        <p>
          Sql Jquery <mark>Bootstrap</mark> <mark>Gsap</mark>{" "}
        </p>
        <p>
          <mark>UX</mark> Shopify <mark>Scss</mark> Vue.js{" "}
        </p>
      </div>
    );
  }
}

export default Tech;
